
import { useState, useEffect } from "react";
import { Investor, Contact } from "@/types/investor";
import EmailContentEditor from "./EmailContentEditor";
import EmailActionsPanel from "./EmailActionsPanel";
import { EmailProvider } from "@/types/email";
import { hasInvestorBeenEmailed } from "@/utils/emailUtils";
import { useEmailManagement } from "@/hooks/useEmailManagement";

interface EmailContentProps {
  investor: Investor;
  selectedContactData: Contact | null;
  generatedEmail: string;
  setGeneratedEmail: (email: string) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  businessInfo: string;
  isSending: boolean;
  setIsSending: (sending: boolean) => void;
  providers: EmailProvider[];
  onEmailSent?: () => void;
  emailSent: boolean;
  setEmailSent: (sent: boolean) => void;
}

const EmailContent = ({
  investor,
  selectedContactData,
  generatedEmail,
  setGeneratedEmail,
  isLoading,
  setIsLoading,
  businessInfo,
  isSending,
  setIsSending,
  providers,
  onEmailSent,
  emailSent,
  setEmailSent
}: EmailContentProps) => {
  // Get current emails from email management hook
  const { emails } = useEmailManagement();

  useEffect(() => {
    // Check database for sent email status whenever investor changes or emails data changes
    setEmailSent(hasInvestorBeenEmailed(investor.id, emails));
  }, [investor.id, emails, setEmailSent]);

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Email Content</h3>
      
      <EmailContentEditor 
        content={generatedEmail} 
        onChange={setGeneratedEmail} 
        isLoading={isLoading} 
      />
      
      <EmailActionsPanel
        investor={investor}
        selectedContactData={selectedContactData}
        generatedEmail={generatedEmail}
        setGeneratedEmail={setGeneratedEmail}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        businessInfo={businessInfo}
        onEmailSent={onEmailSent}
        emailSent={emailSent}
        setEmailSent={setEmailSent}
      />
    </div>
  );
};

export default EmailContent;
